import { hasCrmTeamRole, hasPlatformAdminRole } from '@upme/contracts';
import type { AdminRole } from './auth-context';

/** Первый экран после входа: дашборд только у SUPERADMIN. */
export function defaultAdminHome(roles: readonly AdminRole[]): '/' | '/crm' | '/events' {
  if (roles.includes('SUPERADMIN')) return '/';
  if (hasCrmTeamRole(roles) && !roles.includes('SUPERADMIN')) return '/crm';
  if (hasPlatformAdminRole(roles)) return '/events';
  return '/';
}

export function isCrmTeamMember(roles: readonly AdminRole[]): boolean {
  return hasCrmTeamRole(roles);
}

/** Узкий CRM-режим: legacy CRM_MANAGER без платформенных ролей. */
export function isCrmOnlyWorkspace(roles: readonly AdminRole[]): boolean {
  return roles.includes('CRM_MANAGER') && !roles.includes('SUPERADMIN') && !roles.includes('CITY_MODERATOR');
}
